import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { clearEmptyProperties } from '@core/utils/filters-utils';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';
import english from '../i18n/en.json';
import spanish from '../i18n/es.json';
import portuguese from '../i18n/pt.json';

@Component({
  selector: 'filter-users',
  templateUrl: './filter-users.component.html',
  encapsulation: ViewEncapsulation.None
})
export class FilterUsersComponent implements OnInit {

  public filtersForm: FormGroup;
  public filterChanged = new BehaviorSubject<any>({ archived: false });

  constructor(
    private formBuilder: FormBuilder,
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  async ngOnInit(): Promise<void> {

    this.filtersForm = this.formBuilder.group({
      name: null,
      email: null,
      type: null,
      groupId: null,
      locationId: null,
      archived: false,
    });

    this.filtersForm.valueChanges.pipe(
      debounceTime(500),
      tap(() => {
        const filters = clearEmptyProperties({
          name_contains: this.filtersForm.value.name,
          email_contains: this.filtersForm.value.email,
          type_in: this.filtersForm.value.type,
          group_id: this.filtersForm.value.groupId,
          location_id: this.filtersForm.value.locationId,
          archived: this.filtersForm.value.archived
        });
        this.filterChanged.next(filters);
      })
    ).subscribe();
  }

  clearFilters(): void {
    this.filtersForm.patchValue({
      name: null,
      email: null,
      type: null,
      groupId: null,
      locationId: null,
      archived: false
    });
  }
}
